import React from 'react'
import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { useStyles } from './Styles'
import PageTitle from '../../PageTitle/PageTitle'
import UPTCPForm from './UPTCPForm'

const UPTCPContent = () => {
  const classes = useStyles()
  return (
    <>
      <PageTitle title={<FormattedMessage id='Sidebar.Links.uptcp'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <AuthenticatedUserConsumer>
            {({ importUPTCPFile, importUPTCPFileResults, resetImportUPTCPFileResults }) => (
              <UPTCPForm onSubmit={importUPTCPFile}
                         results={importUPTCPFileResults}
                         resetResults={resetImportUPTCPFileResults}/>
            )}
          </AuthenticatedUserConsumer>
        </Grid>
      </Grid>
    </>
  )
}

export default UPTCPContent
